import { render, staticRenderFns } from "./notificationHistory.vue?vue&type=template&id=c3122a68&scoped=true&"
import script from "./notificationHistory.vue?vue&type=script&lang=js&"
export * from "./notificationHistory.vue?vue&type=script&lang=js&"
import style0 from "./notificationHistory.vue?vue&type=style&index=0&id=c3122a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3122a68",
  null
  
)

export default component.exports